<template>


	<div class="goods" ref="goodsContainer">
	  <div class="productSort">
      <form @submit.prevent="submitForm">
        <div class="header acea-row row-center-wrapper" ref="header">
          <div class="acea-row row-between-wrapper input">
            <span class="iconfont icon-sousuo"></span>
            <input type="text" placeholder="搜索商品" v-model="searchKeyword" class="search-input"/>
          </div>
        </div>
      </form>
	  </div>
	  
	  <div class="content-wrapper"  >
		<!-- 左侧商品种类 -->
		<div class="menu-wrapper" ref='menuScroll'>
			<ul>
				<li v-for="(item,index) in goods" class="menu-item border-1px" :class="{'current':currentIndex===index}" @click="selectMenu(index)">
					<span class="text">
						{{item.name}}
					</span>
				</li>
			</ul>
		</div>
		<!-- 右侧商品详情列表 -->
		<div class="foods-wrapper" ref="foodScroll">
			<ul>
				<li v-for="item in filteredCategories" class="food-list food-list-hook">
					<h1 class="title" style="text-align:center">---{{item.name}}---</h1>
					<ul>
						<li v-for="food in item.foods" class="food-item">
							<div class="content">
								<h2 class="name">
								 <span class="name-text">
									{{food.cp_name}}<span v-if="food.guige"> ({{food.guige}})</span>
								 </span>
								</h2>
								<div class="cartcontrol-wrapper">
									<cartcontrol 
                    :food="food"  
                    :dancicaigou="food.dancicaigou" 
                    v-on:cart-add="cartAdd"
                      @show-input="openInputModal"
                  ></cartcontrol>
								</div>
							</div>
						</li>
					</ul>
				</li>
			</ul>
		</div>
	  </div>
	  
	  <!-- 购物车组件 -->
  	<shopcart ref="shopcart" :selectFood="selectFoods"></shopcart>
	</div>
</template>


<script>
import Vue from 'vue';
import BScroll from 'better-scroll';
import store from "@utils/store/cookie";
import shopcart from '../../components/shopcart/shopcart';
import cartcontrol from '../../components/cartcontrol/cartcontrol'
import { getCategory } from "@api/store";
import InputModal from '../../components/input/InputModal.vue'

export default {
  name: 'goods',
  props: {
    seller: {
      type: Object
    }
  },
  data() {
    return {
      scrollY: 0,
      foodScroll: null,
      goods: [],
      menuScroll: null,
      scrollLocked: false,
      searchKeyword: "",
      foods: [],
      goodslist: [],
      cartlist: [],
      listHeight: [],
      isModalVisible: false,
      keyboardHeight: 0,
      scrollPosition: { left: 0, top: 0 },
      // 新增：记录原始商品数据，避免搜索后影响原始数据
      originalGoods: []
    }
  },
  mounted() {
    this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee'];
    this.cartlist = store.get("cartlist");
    console.log(this.cartlist);
    const uid = store.get("uid");
    
    getCategory().then(res => {
      this.goods = res.goodslist;
      this.originalGoods = JSON.parse(JSON.stringify(res.goodslist)); // 深拷贝保存原始数据
      this.mergeData();
      this.$nextTick(function() {
        this._MenuScroll();
        this._foodScroll();
        this.getHeight();
      })
    });
  },
  
  // 新增：监听搜索关键词变化
  watch: {
    searchKeyword(newVal) {
      // 搜索关键词变化时，重新计算高度
      this.$nextTick(() => {
        this.getHeight();
        // 重置滚动位置到顶部
        if (this.foodScroll) {
          this.foodScroll.scrollTo(0, 0, 300);
        }
        // 重置当前选中分类为第一个
        this.scrollY = 0;
      });
    },
    
    // 监听过滤后的商品列表变化
    filteredCategories: {
      handler() {
        this.$nextTick(() => {
          // 重新计算右侧商品列表高度
          this.getHeight();
          // 刷新BetterScroll
          this.refreshScroll();
        });
      },
      deep: true
    }
  },
  
  computed: {
    filteredCategories() {
     const keyword = this.searchKeyword ? this.searchKeyword.trim().toLowerCase() : '';
      if (!keyword) {
        // 如果没有搜索关键词，返回原始商品数据
        return this.originalGoods;
      }
      
      return this.originalGoods
        .map(category => {
          const newCategory = { ...category };
          newCategory.foods = category.foods.filter(food => 
            food.cp_name && food.cp_name.toLowerCase().includes(keyword)
          );
          return newCategory;
        })
        .filter(category => category.foods.length > 0);
    },
    
    currentIndex() {
      for(let i = 0; i < this.listHeight.length; i++) {
        let height1 = this.listHeight[i];
        let height2 = this.listHeight[i + 1];
        if(!height2 || (this.scrollY >= height1 && this.scrollY < height2)) {
          return i;
        }
      }
      return 0;
    },
   selectFoods() {
      let foods = [];
      // 修复：始终使用 originalGoods 来计算购物车商品，确保数据一致性
      this.originalGoods.forEach(good => {
        good.foods.forEach(food => {
          if(food.count > 0) {
            foods.push(food);
          }
        });
      });
      return foods;
    }
  },
  
  methods: {
    // 新增：刷新BetterScroll
    refreshScroll() {
      if (this.foodScroll) {
        this.foodScroll.refresh();
      }
      if (this.menuScroll) {
        this.menuScroll.refresh();
      }
    },
    
    // 修改getHeight方法，增加错误处理
    getHeight() {
      try {
        let foodList = this.$refs.foodScroll;
        if (!foodList) return;
        
        let foodListChild = foodList.getElementsByClassName('food-list-hook');
        let height = 0;
        this.listHeight = [height];
        
        for(let i = 0; i < foodListChild.length; i++) {
          let item = foodListChild[i];
          if (item && item.clientHeight) {
            height += item.clientHeight;
            this.listHeight.push(height);
          }
        }
        
        // 刷新滚动实例
        this.refreshScroll();
      } catch (error) {
        console.log('计算高度出错:', error);
      }
    },
    
    // 修改selectMenu方法，增加健壮性
    selectMenu(index) {
      let foodList = this.$refs.foodScroll;
      if (!foodList || !this.foodScroll) return;
      
      let foodListChild = foodList.getElementsByClassName('food-list-hook');
      if (index >= 0 && index < foodListChild.length) {
        let el = foodListChild[index];
        this.foodScroll.scrollToElement(el, 300);
      }
    },
    
    // 其他方法保持不变，但需要确保在数据更新后调用refreshScroll
mergeData() {
      if(this.cartlist != null) {
        const countMap = new Map(
          this.cartlist.map(item => [item.cp_id, item.count])
        );
        
        // 同时更新 goods 和 originalGoods，保持数据同步
        [this.goods, this.originalGoods].forEach(goodsArray => {
          goodsArray.forEach(cate => {
            if (cate.foods && cate.foods.length) {
              cate.foods.forEach(food => {
                if (countMap.has(food.cp_id)) {
                  this.$set(food, 'count', countMap.get(food.cp_id));
                } else {
                  // 确保没有购物车数据的商品 count 为 0 或 undefined
                  if (food.count > 0) {
                    this.$set(food, 'count', 0);
                  }
                }
              });
            }
          });
        });
      }  
    },
    
    _MenuScroll() {
      let scrollDOM = this.$refs.menuScroll;
      if (scrollDOM) {
        this.menuScroll = new BScroll(scrollDOM, {
          scrollY: true,
          click: true
        });
      }
    },
    
    _foodScroll() {
      let scrollDOM = this.$refs.foodScroll;
      if (scrollDOM) {
        this.foodScroll = new BScroll(scrollDOM, {
          probeType: 3,
          click: true
        });  
        
        let that = this;
        this.foodScroll.on('scroll', function(pos) {
          that.scrollY = Math.abs(Math.round(pos.y));
        });
        
        // 监听滚动结束，刷新高度计算
        this.foodScroll.on('scrollEnd', () => {
          this.$nextTick(() => {
            this.getHeight();
          });
        });
      }
    },
    
  closeModal(instance, div) {
  console.log(instance);
    this.$nextTick(() => { // Vue官方推荐的DOM更新等待机制
    if (div.parentNode) {
      document.body.removeChild(div);
    }
    instance.$destroy();
	this.modalInstance = null;
    this.unlockScroll();
  });
  
  
  },
    
// 修改输入弹窗的 input 事件处理
    openInputModal(food) {
      console.log('open');
      const ModalComponent = Vue.extend(InputModal);
      const instance = new ModalComponent({
        propsData: {
          value: food.count || 0,
          food: food
        }
      });

      const div = document.createElement('div');
      document.body.appendChild(div);
      instance.$mount(div);
     
      // 监听input事件
      instance.$on('input', value => {
        console.log(value);
        if (value > 0) {
          // 同时更新所有数据源中的对应商品
          this.updateFoodCountInAllSources(food.cp_id, value);
        } else {
          this.removeFoodCountInAllSources(food.cp_id);
        }
        // 同步购物车数据
        this.syncCartData();
      });
       
      instance.$on('close', () => {
        console.log('close');
        instance.$destroy();
        if (instance.$el && instance.$el.parentNode) {
          instance.$el.parentNode.removeChild(instance.$el);
        }
        this.unlockScroll();
      });
    },
	 // 新增：在所有数据源中更新商品数量
    updateFoodCountInAllSources(cp_id, count) {
      [this.goods, this.originalGoods].forEach(goodsArray => {
        goodsArray.forEach(cate => {
          if (cate.foods && cate.foods.length) {
            cate.foods.forEach(food => {
              if (food.cp_id === cp_id) {
                this.$set(food, 'count', count);
              }
            });
          }
        });
      });
    },
	   // 新增：在所有数据源中移除商品数量
    removeFoodCountInAllSources(cp_id) {
      [this.goods, this.originalGoods].forEach(goodsArray => {
        goodsArray.forEach(cate => {
          if (cate.foods && cate.foods.length) {
            cate.foods.forEach(food => {
              if (food.cp_id === cp_id) {
                this.$delete(food, 'count');
              }
            });
          }
        });
      });
    },
    
  // 改进的滚动锁定方法
    lockScroll() {
      // 记录当前滚动位置
      this.scrollPosition = {
        left: window.pageXOffset,
        top: window.pageYOffset
      }
      
      // 锁定body滚动
      document.body.style.position = 'fixed'
      document.body.style.width = '100%'
      document.body.style.top = `-${this.scrollPosition.top}px`
      document.body.style.left = `-${this.scrollPosition.left}px`
      
      // 锁定better-scroll滚动
      if (this.foodScroll) this.foodScroll.disable()
      if (this.menuScroll) this.menuScroll.disable()
    },
    
    unlockScroll() {
      // 恢复body滚动
      document.body.style.position = ''
      document.body.style.width = ''
      document.body.style.top = ''
      document.body.style.left = ''
      
      // 恢复滚动位置
      window.scrollTo(this.scrollPosition.left, this.scrollPosition.top)
      
      // 解锁better-scroll滚动
      if (this.foodScroll) this.foodScroll.enable()
      if (this.menuScroll) this.menuScroll.enable()
    },
    
      cartAdd(target) {
      this.$nextTick(() => {
        this.$refs.shopcart.drop(target);
        // 确保购物车数据同步到所有数据源
        this.syncCartData();
      });
    },
	  // 新增：同步购物车数据方法
    syncCartData() {
      // 获取当前所有有数量的商品
      const cartItems = [];
      this.originalGoods.forEach(cate => {
        cate.foods.forEach(food => {
          if (food.count > 0) {
            cartItems.push({
              cp_id: food.cp_id,
              count: food.count
            });
          }
        });
      });
      
      // 更新到 cookie/store
      store.set("cartlist", cartItems);
      this.cartlist = cartItems;
    },
  },
  
  components: {
    shopcart,
    cartcontrol
  }
}
</script>

<style lang="less" scoped>
@import "../../common/less/index.less";
.search-input {
  padding: 10px;
  width: 300px;
  margin-bottom: 20px;
  border: 0px solid #ddd;
  border-radius: 4px;
}
.goods{
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  top: 50px;
  bottom: 98px;
  height: calc(100vh - 148px);
  overflow: hidden;
}  
.content-wrapper {
  display: flex;
  flex: 1;
  overflow: hidden;
  
  /* 当滚动被锁定时添加的样式 */
  &.no-scroll {
    touch-action: none; /* 禁止触摸滚动 */
    overflow: hidden; /* 隐藏滚动条 */
    position: fixed; /* 防止内容移动 */
    width: 100%;
    height: 100%;
  }
}
.menu-wrapper{
	flex:0 0 110px;
	width:110px;
	background: #f3f5f7;
	.menu-item{
		display:table;
		height:54px;
		width:110px;
		line-height:14px;
		text-align:center;
		font-size: 14px;
		padding: 0 12px;
		&.current{
			background-color: #ffffff;
			font-weight:700;
			position: relative;
			margin-top: -1px;
			z-index: 10;
			.text{
				.border-none();
			}
		}
    .icon{
      display:inline-block;
      width:12px;
      height:12px;
      margin-right: 2px;
      background-size: 12px 12px;
      background-repeat: no-repeat;
      vertical-align:top;
      &.decrease{
        .bg-image('decrease_1')
      }
      &.discount{
        .bg-image('discount_1')
      }
      &.special{
        .bg-image('special_1')
      }             
      &.guarantee{
        .bg-image('guarantee_1')
      }
      &.invoice{
        .bg-image('invoice_1')
      }                                    
    }
    .text{
    	font-size: 12px;
    	display:table-cell;
    	width:56px;
    	vertical-align:middle;
    	color:#07111b;
    	.border-1px(rgba(7,17,27,0.1));
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
	}
}
.foods-wrapper{
	flex:1;
	background-color: #fff;
	.food-list{
		h1{
			font-size: 12px;
			color:#93999f;
			border-left:2px solid #d9dde1;
			height:26px;
			line-height:26px;
			padding-left: 12px;
			background-color: #f3f5f7;
		}
		.food-item{
			display: flex;
			margin: 10px; 
			overflow:hidden;
			.border-1px(rgba(7,17,27,0.1));
			padding-bottom:18px;
			&:last-child{
				.border-none();
				margin-bottom:0;
			}
			.icon{
				flex:0 0 57px;
				img{
					width:100%;
				}
			}
			.content{
        display: flex;
        justify-content: space-between;
        width: 100%;
				margin-left:10px;
				.name {
          flex: 1;
          min-width: 0;
          .name-text {
            display: inline-block;
            max-width: 100%;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
            line-height: 1.4;
          }
        }
				.desc{
					font-size: 10px;
					line-height:12px;
					color:#93999f;
					margin-bottom:8px;
				}
				.extra{
					font-size: 10px;
					line-height:10px;
					color:#93999f;
					.count{
						margin-right:12px;
					}
				}
				.price{
					font-size: 14px;
					font-weight:700;
					line-height:24px;
					.now{
						color:#f01414;
						margin-right:8px;
						font-size: 14px;
						font-weight:700;
					}
					.old{
						text-decoration: line-through;
						font-size: 10px;
						color:#93999f;
						font-weight:700;
					}
				}
				.cartcontrol-wrapper{
          flex: 0 0 100px;
          position: static;
				}
			}
		}
	}
}
</style>